import { tns } from 'tiny-slider/src/tiny-slider';

/**
 * Slider
 * @var Slider
 */
class Slider {
  /**
   * Constructor
   * @param  {HTMLElement} element The root element of the component
   * @return {Slider}              The new Slider instance
   */
  constructor(el) {
    this.sliderContainer = el;
    this.sliderContent = el.querySelector('.slider__content');
    this.sliderNav = el.querySelector('.slider__nav');
    this.previousButton = el.querySelector('.slider__prev');
    this.nextButton = el.querySelector('.slider__next');
    this.currentIndex = el.querySelector('.slider__current-index');
    this.totalIndex = el.querySelector('.slider__total-index');
    this.marker = el.querySelector('.slider__marker');
  }

  /**
   * Initialize the slider
   * @return {Slider} The current instance
   */
  init() {
    this.slider = tns({
      container: this.sliderContent,
      swipeAngle: false,
      speed: 400,
      items: 1,
      center: false,
      mouseDrag: true,
      slideBy: 1,
      navContainer: this.sliderNav,
      prevButton: this.previousButton,
      nextButton: this.nextButton,
      startIndex: 0,
      onInit: this.onInit.bind(this),
      responsive: {
        768: {
          center: true,
          items: 2,
        },
      },
    });

    this.slider.events.on('indexChanged', this.onSlideChange.bind(this));

    return this;
  }

  /**
   * On slide change
   * @param info
   */
  onSlideChange(info) {
    const slides = this.sliderContainer.querySelectorAll('.tns-item');
    const active = this.sliderContainer.querySelector('.slider__slide--active');
    active.classList.remove('slider__slide--active');
    this.currentIndex.innerHTML = info.displayIndex;
    /* eslint-disable-next-line */
    this.marker.style.transform = `translate3d(${100 *(info.displayIndex - 1)}%, 0, 0)`;

    slides[info.index].classList.add('slider__slide--active');
  }

  /**
   * On init
   *
   * @param info
   */
  onInit(info) {
    const slides = this.sliderContainer.querySelectorAll('.tns-item');
    this.currentIndex.innerHTML = info.displayIndex;
    this.totalIndex.innerHTML = info.slideCount;
    this.marker.style.width = `${100 / info.slideCount}%`;

    slides[info.index].classList.add('slider__slide--active');
  }
}

const elements = document.querySelectorAll('.slider');

const sliders = Array.from(elements).map(element => new Slider(element).init());
export default sliders;
